import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../config/api';

// Create AuthContext
const AuthContext = createContext();

// Custom hook to access AuthContext easily
export const useAuth = () => useContext(AuthContext);

// Session lives in an httpOnly cookie set by the backend. Nothing auth-related is stored in the browser;
// the role is kept in memory and re-fetched from /auth/me on every page load.
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // { role, name }
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Clean up the old localStorage-based login
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
    } catch (e) { /* ignore */ }

    authApi.get('/auth/me')
      .then((res) => setUser({ role: res.data.role, name: res.data.name }))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = (role, name) => {
    setUser({ role, name });
  };

  const logout = async () => {
    try {
      await authApi.post('/auth/logout');
    } catch (e) { /* cookie may already be gone */ }
    setUser(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{
      isLoggedIn: !!user,
      role: user?.role || null,
      name: user?.name || null,
      loading,
      login,
      logout,
    }}>
      {children}
    </AuthContext.Provider>
  );
};
